/**
 * NumericField · txn kit (presentation only)
 * Thin wrapper over the shared FormattedNumberInput so every quantity cell
 * behaves identically: focus-stable continuous typing (raw draft on focus),
 * thousands/decimal formatting on blur, right-aligned mono. No business logic.
 */
import React from "react";
import FormattedNumberInput from "@/components/FormattedNumberInput";

const BASE =
  "w-full h-9 px-3 bg-[var(--bg-0)] border rounded-sm text-sm text-right font-mono text-[var(--fg-0)] placeholder:text-[var(--fg-3)] focus:outline-none transition-colors";

export default function NumericField({
  value,
  onChange,
  step = "0.001",
  min,
  max,
  placeholder = "0.000",
  invalid = false,
  disabled = false,
  readOnly = false,
  className = "",
  ...rest
}) {
  const stateCls = invalid
    ? "border-red-500/60 focus:border-red-500"
    : "border-[var(--border)] focus:border-[var(--accent)]";
  const lockCls = disabled || readOnly ? "opacity-70 cursor-not-allowed" : "";
  return (
    <FormattedNumberInput
      value={value}
      onChange={onChange}
      step={step}
      min={min}
      max={max}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      className={`${BASE} ${stateCls} ${lockCls} ${className}`}
      {...rest}
    />
  );
}
